import { render, staticRenderFns } from "./locale_selector.vue?vue&type=template&id=2124919e&scoped=true&"
import script from "./locale_selector.vue?vue&type=script&lang=ts&"
export * from "./locale_selector.vue?vue&type=script&lang=ts&"
import style0 from "./locale_selector.vue?vue&type=style&index=0&id=2124919e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2124919e",
  null
  
)

export default component.exports